<template>
  <div class="card table">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CardList'
}
</script>
